module.exports = __webpack_public_path__ + "static/media/entertain-easy-rider.56717036.vtt";